import { render, staticRenderFns } from "./StatusGateway.vue?vue&type=template&id=1ada1014&scoped=true"
import script from "./StatusGateway.vue?vue&type=script&lang=js"
export * from "./StatusGateway.vue?vue&type=script&lang=js"
import style0 from "./StatusGateway.vue?vue&type=style&index=0&id=1ada1014&prod&lang=scss&scoped=true"
import style1 from "./StatusGateway.vue?vue&type=style&index=1&id=1ada1014&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ada1014",
  null
  
)

export default component.exports